export interface TerminalWebComponentSchema {
  // all the data needed for rendering
  isIdpRequestAuthorized: boolean;
  isMdrGracePeriod: boolean;
}

export const CONNECTION_SUCCESSFUL = 'connectionSuccessful';
export const CONNECTION_FAILED = 'connectionFailed';
export const CONNECTION_ERROR = 'connectionError';
export const START_CONNECTION = 'startConnection';
export const CONNECTION_INACTIVE = 'connectionInactive';
export const CONNECTION_ENDED = 'connectionEnded';

export const DownloadFinishedErrorCodes = {
  SUCCESS: 0,
  FILE_ALREADY_EXISTS: 183,
  NOT_PROCESSED: 995,
  OPERATION_CANCELLED: 1223,
  PATH_NOT_FOUND: 3,
  RELATIVE_PATH: 267,
  ACCESS_DENIED_BEST_DIR: 313,
  INVALID_PATH: 2,
  ACCESS_DENIED: 5,
  NOT_FOUND: 404,
};

export const UploadFinishedStatus = {
  SUCCESS: 'success',
  GATHER_ITEMS_FAILED: 'gather items failed',
  UPLOAD_FAILED: 'upload failed',
  ABORTED: 'aborted',
};

export const UploadFinishedErrorCodes = {
  INTERNAL_ERROR_WEBCOMPONENTS: -1,
  GATHER_ITEMS_FAILED: -100,
  UNKNOWN_ERROR: -101,
  CANCELLED_BY_USER: -102,

  // Items errors
  SUCCESS: 0,
  NOT_PROCESSED: 995,
  INVALID_NAME: 123,
  ERROR_BAD_PATHNAME: 161,
  RELATIVE_PATH: 267,
  PATH_NOT_FOUND: 2,
  EMPTY_FILES: 232,
  ACCESS_DENIED: 313,
  INTERNAL_ERROR: 1359,
  INCOMPLETE_PACKING: 996,
  PACKING_FAILED: 15616,

  // Centralized storage errors
  INVALID_PROFILE: 1168,
  MAX_SIZE_EXCEEDED: 223,
  TIMEOUT_REACHED: -1011,
  UPLOAD_CANCELLED: 1223,
  INVALID_SERVER: -1002,
  INVALID_PROXY: -1003,
  COULD_NOT_CONNECT: -1004,
  COULD_NOT_LOGIN: -1005,
};

export const PrevalidateUploadPathForEndpointErrorCodes = {
  SUCCESS: 0,
  PATH_NOT_FOUND: 2,
  INVALID_NAME: 123,
  RELATIVE_PATH: 267,
  EMPTY_DIRECTORY: 4306,
  INVALID_PROFILE: 1168,
  MAX_FILE_SIZE_EXCEEDED: 223,
  INTERNAL_ERROR: 1359,
  ACCESS_DENIED: 5,
};

export interface UploadedFile {
  sourceUri: string;
  to: string;
  error: string;
  errorCode: number;
}

export interface DownloadedFile {
  pattern: string;
  errorCode: number;
}
